import { Flex } from '@atlaskit/primitives';

import type { FunctionComponent } from 'react';
import Headline from './Headline';
import Scopes from './Scopes/Scopes';

const OIDC: FunctionComponent = () => (
  <Flex gap="space.400" direction="column" wrap="wrap" alignItems="start">
    <Flex alignItems="center" direction="column" gap="space.400">
      <Headline />
    </Flex>
    <Scopes />
  </Flex>
);

export default OIDC;
